import { ILogger } from './types';

export class LoggerService<Tag extends string = string>
  implements ILogger<Tag>
{
  constructor(private logger: ILogger<Tag>) {}

  setLogger = (logger: ILogger<Tag>) => {
    this.logger = logger;
  };

  log = (message: string, messageContext?: Record<string, unknown>) => {
    this.info(message, messageContext);
  };

  debug = (
    tag: Tag,
    message: string,
    messageContext?: Record<string, unknown>,
  ) => {
    if (messageContext) {
      this.logger.debug(tag, message, messageContext);
    } else {
      this.logger.debug(tag, message);
    }
  };

  info = (message: string, messageContext?: Record<string, unknown>) => {
    if (messageContext) {
      this.logger.info(message, messageContext);
    } else {
      this.logger.info(message);
    }
  };

  warn = (message: string, messageContext?: Record<string, unknown>) => {
    if (messageContext) {
      this.logger.warn(message, messageContext);
    } else {
      this.logger.warn(message);
    }
  };

  error = (message: unknown, messageContext?: unknown) => {
    if (messageContext) {
      this.logger.error(message, messageContext);
    } else {
      this.logger.error(message);
    }
  };
}
